import React from 'react'
import Router from 'react-router'
import routes from '_/shared/routes'
import Store from '_/shared/store'
import InternalError from '_/shared/pages/internalError'
import setupKeyBindings from '_/utils/setupKeyBindings'

/**
 * Set up client-side router
 */
export default function setupRoutes () {
  if (!global.REACT_STORE_STATE) return

  // Set up store with any server sent data
  const store = new Store()
  store.hydrate(global.REACT_STORE_STATE || {})

  // We skip the first fetch as we already
  // have the data from the server
  let skipFetch = true
  let lastError
  let appEl = document.getElementById('app')

  function reload () {
    if (appEl) appEl.remove()
    appEl = document.createElement('div')
    appEl.id = 'app'
    document.body.appendChild(appEl)
  }

  const router = Router.create({
    routes: routes,
    location: Router.HistoryLocation
  })

  setupKeyBindings(router)
  // Include HTML5 PushState to match server URIs
  router.run(async (Handler, state) => {
    if (state.path === '/') return // Do not router/render landing page (only when isDebug)

    try {
      await Promise.resolve(!skipFetch && store.fetchData(state))
      React.render(<Handler store={store} lastError={lastError} {...store.data} />, appEl)
      skipFetch = false
    } catch (er) {
      lastError = er
      console.error(er)
      try {
        reload()
        React.render(<InternalError error={er} />, appEl)
      } catch (er) {
        console.error(er)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./modules/client/router.js